import FixaTable, {
  FixaTableBody,
  FixaTableHeader,
} from "@coworker/apprestructured/src/shared/wrappers/FixaTable/FixaTable";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import TrashCanIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/TrashCanIconPath";
import { FixaSwitch } from "@coworker/apprestructured/src/shared/wrappers/FixaSwitch/FixaSwitch";
import { StorePermission } from "../../types/StorePermission";

type Props = {
  permissions: StorePermission[];
  isLoading: boolean;
  onToggle: (id: number, currentValue: boolean) => void;
  onDelete: (id: number) => void;
};

const StorePermissionsPanel = ({
  permissions,
  isLoading,
  onToggle,
  onDelete,
}: Props) => {
  return (
    <FixaTable fullWidth>
      <FixaTableHeader>
        <tr>
          <th>ID</th>
          <th>Store ID</th>
          <th>Permission Code</th>
          <th>Value</th>
          <th>Delete</th>
        </tr>
      </FixaTableHeader>
      <FixaTableBody>
        {isLoading ? (
          <tr>
            <td colSpan={5}>Loading...</td>
          </tr>
        ) : permissions.length === 0 ? (
          <tr>
            <td colSpan={5}>No store permissions found</td>
          </tr>
        ) : (
          [...permissions]
            .sort((a: StorePermission, b: StorePermission) => a.id - b.id)
            .map((permission: StorePermission) => (
              <tr key={permission.id}>
                <td>{permission.id}</td>
                <td>{permission.store_id}</td>
                <td>{permission.permission_id}</td>
                <td>
                  <FixaSwitch
                    checked={permission.value}
                    id={`store-permission-${permission.id}`}
                    value={permission.value.toString()}
                    onChange={() => onToggle(permission.id, permission.value)}
                  />
                </td>
                <td>
                  <FixaButton
                    iconOnly={true}
                    size="small"
                    ssrIcon={TrashCanIconPath}
                    onClick={() => onDelete(permission.id)}
                  />
                </td>
              </tr>
            ))
        )}
      </FixaTableBody>
    </FixaTable>
  );
};

export default StorePermissionsPanel;
